<template>
    <div
        :class="[
            'md-house',
            'grid-v1',
            'grid',
            'template1',
            morePosition === 'top' ? 'top-more' : ''
        ]"
        v-if="result && result.listings && result.listings.length > 0"
    >
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
        >
            <div class="house-title" :class="title ? '': 'no-title'">
                <div class="mg-title" v-html="formatFontSize(title, '--mg-title-size')"></div>
                <div v-if="desc" class="desc" v-html="desc"></div>
                <a
                    v-if="moreText"
                    class="mg-more"
                    :href="moreLink"
                    :aria-label="moreLinkPurpose"
                    :style="moreStyle"
                    rel="noopener noreferrer"
                >
                    {{ moreText }}
                    <i class="iconfont icon-more_arrow"></i>
                </a>
            </div>
            <Grid
                :class="{ 'full-screen': fullColumn }"
            />
            <div class="more-con">
                <a
                    v-if="moreText"
                    class="mg-more"
                    :href="moreLink"
                    :aria-label="moreLinkPurpose"
                    :style="moreStyle"
                    rel="noopener noreferrer"
                >
                    {{ moreText }}
                    <i class="iconfont icon-more_arrow"></i>
                </a>
            </div>
            <MlsDesclaimer v-if="wordPressSSR" theme="classic" />
        </module-box>
    </div>
    <div v-else-if="waiting" class="waiting"></div>
</template>

<script>
import Core from '../index';
import { getAsyComponent } from '@/common/utils/load-module.js';
export default {
    mixins: [Core],
    components: {
        Grid: getAsyComponent(() =>
            import(
                /* webpackChunkName: "modules/md-house/grid-v1_grid"*/ './grid.vue'
            )),
    }
};
</script>
<style lang="scss">
.md-house.grid.template1 {
    .mg-container{
        overflow: visible;
    }
    .mg-more {
        @media (min-width: 801px) {
            margin: 40px 0 0;
        }
        .iconfont {
            font-size: 14px;
            margin-left: 5px;
        }
    }
}
</style>
